import ApiService from "./ApiService";

/**
 * Service handling trace requests
 */
const TraceService = {
  async getTraces(): Promise<Trace[]> {
    return ApiService.get("/traces");
  },
  async getTraceById(id: number): Promise<Trace> {
    return ApiService.get(`/traces/${id}`);
  },
  async createTrace(trace: Trace, userId: number | null): Promise<Trace> {
    return ApiService.post("/traces", {
      beginDate: trace.beginDate,
      endDate: trace.endDate,
      isActive: trace.isActive,
      points: trace.points,
      userId,
    });
  },
  async addPointToTrace(trace: Trace, point: Point): Promise<Trace> {
    return ApiService.post("/traces/add-point", {
      traceId: trace.id,
      x: point.x,
      y: point.y,
      z: point.z,
    });
  },
  async removePointFromTrace(point: Point): Promise<Trace> {
    return ApiService.post("/traces/remove-point", {
      pointId: point.id,
    });
  },
  async updateTrace(trace: Trace, userId: number | null): Promise<Trace> {
    return ApiService.put("/traces", {
      id: trace.id,
      beginDate: trace.beginDate,
      endDate: trace.endDate,
      isActive: trace.isActive,
      userId,
    });
  },
  async deleteTrace(trace: Trace) {
    return ApiService.delete(`/traces/${trace.id}`);
  },
};

export default TraceService;
